export const useStyles = theme => ({
  requiredAsterisk: {
    color: 'red',
  },
});
